import * as DE from '@nll/datum/lib/DatumEither';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { makeHubApiRequest } from './make-request';
export function useHubApi(_ref) {
  var url = _ref.url,
      method = _ref.method,
      outputCodec = _ref.outputCodec,
      data = _ref.data,
      params = _ref.params,
      _ref$dependencyList = _ref.dependencyList,
      dependencyList = _ref$dependencyList === void 0 ? [] : _ref$dependencyList,
      _ref$executeApi = _ref.executeApi,
      executeApi = _ref$executeApi === void 0 ? true : _ref$executeApi,
      jwt = _ref.jwt,
      currentHubURL = _ref.currentHubURL;

  var _useState = useState(DE.initial),
      result = _useState[0],
      setResult = _useState[1];

  useEffect(function () {
    setResult(DE.toRefresh); // CancelToken is an exported type from axios (but we are using axios.CancelToken)
    //eslint-disable-next-line import/no-named-as-default-member

    var _axios$CancelToken$so = axios.CancelToken.source(),
        cancelToken = _axios$CancelToken$so.token,
        cancel = _axios$CancelToken$so.cancel;

    if (executeApi) {
      makeHubApiRequest({
        jwt: jwt,
        currentHubURL: currentHubURL,
        method: method,
        url: url,
        outputCodec: outputCodec,
        data: data,
        params: params,
        cancelToken: cancelToken,
        onData: setResult
      });
    } else {
      setResult(DE.toReplete);
    }

    return cancel;
  }, dependencyList);
  return result;
}